
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CorspdcService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('correspondence', http, authentication);
  }


  searchCorrespondenceLogs(keyword: any, PageNum: number, PageSize: number) {
    return this.http.post(`${this.url}/log/search/${PageNum}/${PageSize}`, keyword);
  }

  listCarrier = () => {
    return this.getRequest(`${this.url}/carrier/ddl`);
  }

  listBatches(PageNum: number, PageSize: number) {
    return this.getRequest(`${this.url}/batches/${PageNum}/${PageSize}`);
  }

  runSend = () => {
    return this.getRequest(`${this.url}/send`);
  }
  sendMail(payload){
    let url:any=this.url;
    return this.http.post(url,payload);
  }

  savePermitCorrespondence(payload, oldAppId, permitStatus, isApplication) {    
    console.log(oldAppId);
    let url: any = `${this.url}/save/permit/${oldAppId}/${permitStatus}/${isApplication}`;
   
    return this.http.post(url, payload);
  }
}